import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14e5c9d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-14e5c9d7><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" data-v-14e5c9d7><linearGradient id=\"G1\" gradientUnits=\"userSpaceOnUse\" x1=\"7.2738\" y1=\"14.0868\" x2=\"7.2738\" y2=\"5.1879\" data-v-14e5c9d7><stop offset=\"0.4925\" style=\"stop-color:#FFFFFF;\" data-v-14e5c9d7></stop><stop offset=\"1\" style=\"stop-color:#D37C5C;\" data-v-14e5c9d7></stop></linearGradient><polygon fill=\"url(#G1)\" points=\"12.548,11.969 8.357,9.563 8.357,5.903 5.829,4.458 5.829,8.25 4.24,7.302 2,8.688  5.829,11.021 5.829,19.553 8.357,21 8.357,12.407 10.163,13.5 \" data-v-14e5c9d7></polygon><linearGradient id=\"G2\" gradientUnits=\"userSpaceOnUse\" x1=\"4.1094\" y1=\"776.0623\" x2=\"19.2547\" y2=\"776.0623\" gradientTransform=\"matrix(1 0 0 1 0 -768)\" data-v-14e5c9d7><stop offset=\"0.4925\" style=\"stop-color:#FFFFFF;\" data-v-14e5c9d7></stop><stop offset=\"1\" style=\"stop-color:#D37C5C;\" data-v-14e5c9d7></stop></linearGradient><polygon fill=\"url(#G2)\" points=\"8.141,3 21,10.292 21,13.125 5.829,4.458 \" data-v-14e5c9d7></polygon><linearGradient id=\"G3\" gradientUnits=\"userSpaceOnUse\" x1=\"19.322\" y1=\"781.0015\" x2=\"8.0657\" y2=\"787.4123\" gradientTransform=\"matrix(1 0 0 1 0 -768)\" data-v-14e5c9d7><stop offset=\"0.4925\" style=\"stop-color:#FFFFFF;\" data-v-14e5c9d7></stop><stop offset=\"1\" style=\"stop-color:#D37C5C;\" data-v-14e5c9d7></stop></linearGradient><polygon fill=\"url(#G3)\" points=\"8.357,21 21,13.125 21,10.292 8.357,18.094 \" data-v-14e5c9d7></polygon><linearGradient id=\"G4\" gradientUnits=\"userSpaceOnUse\" x1=\"10.4841\" y1=\"18.1785\" x2=\"6.2966\" y2=\"10.366\" data-v-14e5c9d7><stop offset=\"0.4925\" style=\"stop-color:#FFFFFF;\" data-v-14e5c9d7></stop><stop offset=\"1\" style=\"stop-color:#D37C5C;\" data-v-14e5c9d7></stop></linearGradient><path fill=\"url(#G4)\" d=\"M8.357,9.563v2.844l1.806,1.094l2.384-1.531L8.357,9.563z M5.829,19.553L8.357,21v-8.593 l-2.528-1.385V19.553z\" data-v-14e5c9d7></path></svg></div>", 1)
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "navSwitch" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State } from '@/store/i18'
import SwitchMode from '@/views/components/SwitchMode.vue';
import SwitchLang from "@/views/components/SwitchLang.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[i18.name])
const lang = computed<any>(() => data.value.texts[data.value.lang.list[data.value.lang.now]].topMenu)
const route = useRoute()
const categories = [
    { key: 'movie', icon: 'i-menu-1', path: '/' },
    { key: 'live', icon: 'i-a-zu542', path: '/lives' },
    { key: 'bible', icon: 'i-menu-3', path: '/bibles' },
    { key: 'article', icon: 'i-a-ziyuan1', path: '/articles' },
]

const current = computed(() => {
    if (route.path.startsWith('/lives')) {
        return 'live'
    } else if (route.path.startsWith('/bibles')) {
        return 'bible'
    } else if (route.path.startsWith('/articles')) {
        return 'article'
    } else {
        return 'movie'
    }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (item, i) => {
        return _createVNode(_component_router_link, {
          key: i,
          class: _normalizeClass({ on: _unref(current) == item.key }),
          to: item.path
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["icon", item.icon])
            }, null, 2),
            _createElementVNode("div", null, _toDisplayString(_unref(lang)[item.key]), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(SwitchLang),
      _createVNode(SwitchMode)
    ])
  ]))
}
}

})